import React from 'react';
import { renderToString } from 'react-dom/server';
import { colors } from '@alixpartners/ui-components';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getFormattedSpendWithSymbol } from 'utils/number';
import {
	ChartContainer,
	TooltipColor,
	TooltipContainer,
	TooltipItem,
	TooltipItemName,
	TooltipItemTitle,
	TooltipItemValue,
	LegendContainer,
	LegendItem,
	LegendColor,
	LegendColorLine,
	LegendColorDot,
	LegendName,
} from '../ShareOfTotalSpendSection/SpendByVendorChart/styles';
import { Legend } from './styles';
import { MONTHS_LETTER_TO_WORD, getTickInterval } from './utils';

export const SpendOverTimeChart = ({
	categories,
	chartRef,
	currency,
	currencySymbol,
	series,
	width = '100%',
}) => {
	let labelYears = [];
	const tickInterval = getTickInterval(categories.length);
	const chartOptions = {
		chart: {
			type: 'line',
		},
		title: {
			text: '',
		},
		credits: { enabled: false },
		exporting: { enabled: false },
		xAxis: {
			title: {
				enabled: false,
			},
			categories,
			labels: {
				formatter: function() {
					if (tickInterval === 12) {
						return this.value;
					}
					const [month, year] = this.value.split('|');
					let yearStr = '';
					if (!labelYears.includes(year)) {
						yearStr = year;
						labelYears.push(year);
					}
					return renderToString(
						<Legend>
							<div>{month}</div>
							<br />
							<strong>{yearStr}</strong>
						</Legend>
					);
				},
			},
			gridLineWidth: 1,
			tickInterval,
		},
		yAxis: {
			gridLineWidth: 0,
			title: {
				align: 'high',
				text: currency,
				textAlign: 'right',
				rotation: 0,
				y: -20,
				x: 40,
			},
			labels: {
				formatter: function() {
					return getFormattedSpendWithSymbol(this.value, currencySymbol);
				},
			},
		},
		legend: {
			enabled: false,
		},
		tooltip: {
			shared: true,
			useHTML: true,
			backgroundColor: colors.white,
			borderWidth: 0,
			borderRadius: 2,
			outside: true,
			formatter: function() {
				const { year, month } = this.points[0].point;
				return renderToString(
					<TooltipContainer>
						<TooltipItemTitle>
							{`${MONTHS_LETTER_TO_WORD[month]} ${year}`}
						</TooltipItemTitle>
						{this.points.map(item => (
							<TooltipItem key={`${item.point.series.name}-${item.point.y}`}>
								<span>
									<TooltipColor color={item.color} />
									<TooltipItemName>{item.point.series.name}</TooltipItemName>
								</span>
								<TooltipItemValue>
									{getFormattedSpendWithSymbol(
										item.point.spend,
										currencySymbol
									)}
								</TooltipItemValue>
							</TooltipItem>
						))}
					</TooltipContainer>
				);
			},
		},
		plotOptions: {
			series: {
				marker: {
					states: {
						hover: {
							lineWidthPlus: 0,
							radiusPlus: 0,
						},
					},
					enabled: false,
					symbol: 'circle',
					radius: 6,
					radiusPlus: 0,
				},
			},
		},
		series,
	};
	return (
		<ChartContainer width={width}>
			<HighchartsReact
				highcharts={Highcharts}
				options={chartOptions}
				ref={chartRef}
			/>
			<LegendContainer>
				{series.map(serie => (
					<LegendItem key={`${serie.name}`}>
						<LegendColor color={serie.color}>
							<LegendColorLine color={serie.color} />
							<LegendColorDot color={serie.color} />
						</LegendColor>
						<LegendName>{serie.name}</LegendName>
					</LegendItem>
				))}
			</LegendContainer>
		</ChartContainer>
	);
};

export default SpendOverTimeChart;
